import { render } from "./ApprovalPickRequest.vue?vue&type=template&id=678b120b&scoped=true"
import script from "./ApprovalPickRequest.vue?vue&type=script&lang=js"
export * from "./ApprovalPickRequest.vue?vue&type=script&lang=js"

import "./ApprovalPickRequest.vue?vue&type=style&index=0&id=678b120b&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678b120b"]])

export default __exports__